module.exports = __webpack_public_path__ + "img/logo.a4a234a5.svg";